import React from 'react';

import RuleDetailsContainer from '@totem/components/rulesEngine/details/ruleDetailsContainer';
import RuleDetailsLayout, {
  RuleDetailsExtra,
} from '@totem/components/rulesEngine/details/ruleDetailsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const RuleDetailsPage = () => (
  <ContentLayout>
    <RuleDetailsContainer>
      <IBCard isCovered title="Rule Details" extra={<RuleDetailsExtra />}>
        <RuleDetailsLayout />
      </IBCard>
    </RuleDetailsContainer>
  </ContentLayout>
);

export default RuleDetailsPage;
